<style src="./QuotationCart.scss" lang="scss" scoped></style>
<i18n src="./QuotationCart.txt" lang="yaml"></i18n>
<script src="./QuotationCart.js"></script>

<template>
    <div class="quotation-cart-container">
    <!-- <div
      v-if="cartNotEmpty(cart)"
      class="breadcrumb-area bg-gray"
    >
      <div class="container-fluid">
        <div class="breadcrumb-content text-center">
          <div class="breadcrumb-title">
            <h2>{{ t('yourCart') }}</h2>
          </div>
          <ul>
            <li>
              <router-link to="/">Home</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <Spinner v-if="loading" />
    <div
      class="cart-main-area pt-50 pb-100"
      v-else-if="cartNotEmpty(quote.quotationCart)"
    >
      <div class="container-fluid pl-50 pr-50">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <form>
              <div class="row">
                <div class="col-lg-12">
                  <h4 class="text-center sub-heading pb-4"><u>Cart Items</u></h4>
                  <CartLikeContentDetail
                    :cart="quote.quotationCart"
                    :editable="true"
                    :isQuotationCart="true"
                    :quoteRefetch="quoteRefetch"
                  />
                </div>
                <!-- <div class="col-lg-4">
                  <CartLikePriceDetail
                    :cart="cart"
                    :editable="true"
                    class="total-price-calc"
                  />
                </div> -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!cartNotEmpty(quote.quotationCart)"
      class="empty-area mt-50 border-top-2 pt-120 pb-120"
    >
      <div class="container">
        <div
          class="empty-content text-center"
          data-test="empty-cart"
        >
          <h2>{{ t('yourCart') }}</h2>
          <p>{{ t('empty') }}</p>
          <router-link to="/">{{
            t('continueShopping')
          }}</router-link>
        </div>
      </div>
    </div>
    <div class="row pl-50 pr-50">
        <div class="col-lg-12">
          <h4 class="text-center sub-heading pb-4"><u>Discounts</u></h4>
        </div>
    </div>
    <div class="row mt-2 px-5">
      <div class="col-12">
        <label><b>Direct Discount</b>
          <abbr title="This is a light representation of CartDiscount. It is associated only with a single Cart or Order and cannot be associated with any other.">?</abbr>
          <input
            v-model="discountType"
            type="radio"
            value="direct"
            name="discount_type"
            class="discount_radio_button d-none"
          />
        </label>
      </div>
      <!-- <div class="col-6">
      <label>Cart Discounts
      <input
        v-model="discountType"
        type="radio"
        value="cart"
        name="discount_type"
        class="discount_radio_button"
      /></label>
    </div> -->
    </div>
    <div class="col-lg-6 col-md-6 mt-2 px-5" v-if="discountType === 'direct'">
        <div class="billing-info">
            <label>
              Enter the discount Value
            </label>
            <input type="number" v-model="discountValue" />
            <span class="error" v-if="discountValue < 0 || discountValue > 80">Discount value can range from 0% to 80%</span>
        </div>
    </div>
    <div class="Col-lg-6 col-md-6 mt-2 px-5" v-if="discountValue != null && discountValue.toString().length && (discountValue >=0 || discountValue <=80) && discountTotal>0">
      <p class="discount-total">Total after applying {{discountValue}}% discount is {{  discountTotal }}</p>
    </div>
    <!-- <div class="col-lg-6 col-md-6 my-2 px-5" v-if="discountType === 'cart'">
        <div class="billing-info">
            <label>
              Select Cart Discounts
            <abbr class="required">*</abbr>
            </label>
            <select class="discount-dropdown">
              <option>50% discount</option>
            </select>
        </div>
    </div> -->
    <div class="col-lg-12 col-md-12 mt-2 px-5">
        <div class="billing-info">
            <label>
            Seller Comments
            </label>
            <textarea
            type="text"
            data-test="address-form-city"
            v-model="quoteComment"
            ></textarea>
        </div>
    </div>
  </div>
</template>